import SearchJobs from "../../components/candidate/searchJobs";

const SearchCandidatePage = () => {
  return <SearchJobs />;
};

export default SearchCandidatePage;
